const initialState = {
    groupPermissions:{},
    groupLists: [],
    groupStatus: [],
    changedGroupStatus : [],
    loadingGroup: false,
    errorsGroup
: {}
}

const  groupReducer = (state = initialState, action) => {
    switch (action.type) {
        case "GET_GROUPLIST_PENDING":
        case "ADD_GROUP_PENDING":
        case "UPDATE_GROUP_PENDING":
        case "UPDATE_GROUP_STATUS_PENDING":
        case "DELETE_GROUP_PENDING":
        case "GET_GROUPLISTBYID_PENDING":
            return { ...state, loadingGroup: true };

        case "GET_GROUPLIST_FULFILLED":
            return {
                ...state,
                loadingGroup: false,
                groupLists: action.payload,
                groupCount: action.groupCount,
                groupPermissions:action.permissions,
            };

        case "ADD_GROUP_FULFILLED":
            return {
                ...state,
                loadingGroup: false,
                changedGroupStatus: action.payload,
            };

        case "UPDATE_GROUP_FULFILLED":
            return {
                ...state,
                loadingGroup: false,
                changedGroupStatus: action.payload,
            };

        case "UPDATE_GROUP_STATUS_FULFILLED":
            return {
                ...state,
                loadingGroup: false,
                changedGroupStatus: action.payload,
            };

        case "GET_GROUPLISTBYID_FULFILLED":
            return {
                ...state,
                loadingGroup: false,
                groupLists: action.payload
            };

        case "DELETE_GROUP_FULFILLED":
            return {
                ...state,
                loadingGroup: false,
                changedGroupStatus: action.payload
            };

        case "RESET_DELETE_GROUP_STATUS":
            return {
                ...state,
                loadingGroup: false,
                changedGroupStatus: [],
                errorsGroup
:{}
            };

        case "GET_GROUPLIST_REJECTED":
        case "ADD_GROUP_REJECTED":
        case "UPDATE_GROUP_REJECTED":
        case "UPDATE_GROUP_STATUS_REJECTED":
        case "DELETE_GROUP_REJECTED":
        case "GET_GROUPLISTBYID_REJECTED":
            return {
                ...state,
                loadingGroup: false,
                errorsGroup
: action.payload
            };

        default:
            return state;
    }
}

export default groupReducer;